module.exports = "<h1>Welcome back, {{user?.firstname}}!</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-dashboard/admin-dashboard.component.html
// module id = ./src/app/components/admin/admin-dashboard/admin-dashboard.component.html
// module chunks = main